module.exports = __webpack_public_path__ + "static/img/barcode_img.04050b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/barcode_img.jpg
// module id = k6hT
// module chunks = 1